import React from 'react';
import { useNotifications } from '../../hooks/useNotifications';

interface NotificationBadgeProps {
  showBadge?: boolean;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ showBadge = false }) => {
  const { unreadCount } = useNotifications();

  if (!showBadge || !unreadCount || unreadCount <= 0) {
    return null;
  }

  return (
    <span className="absolute top-1 right-1 w-1.5 h-1.5 bg-green-500 rounded-full"></span>
  );
};

export default React.memo(NotificationBadge);